import { useHistory } from "react-router-dom";
import { Container, Title, Description, Button, IconContainer } from "./style";

export function NotFound() {
	const history = useHistory();

	return (
		<Container>
			<IconContainer>
				<svg
					width="200"
					height="200"
					viewBox="0 0 200 200"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					role="img"
					aria-label="404 Not Found"
				>
					<circle
						cx="100"
						cy="100"
						r="95"
						stroke="var(--colorButton)"
						strokeWidth="2"
						opacity="0.2"
					/>
					<text
						x="100"
						y="120"
						fontSize="80"
						fontWeight="bold"
						textAnchor="middle"
						fill="var(--colorButton)"
						opacity="0.3"
					>
						404
					</text>
				</svg>
			</IconContainer>

			<Title>Página não encontrada</Title>

			<Description>
				Desculpe, a página que você está procurando não existe ou foi removida.
			</Description>

			<Button onClick={() => history.push("/")}>Voltar para a início</Button>
		</Container>
	);
}
